// 權限碼清單（與後端 constant/Permission.java 對齊，由程式碼定義、使用者不可新增）。
// 一個碼 = 能管理這塊（含看 + 改），目前不分讀/寫。
export const PERMISSIONS = [
  { code: 'dashboard', label: '儀表板',      desc: '檢視後台儀表板' },
  { code: 'theme',     label: '主題圖鑑',    desc: '新增、編輯、刪除主題圖鑑' },
  { code: 'virtual',   label: '虛擬商品',    desc: '管理虛擬商品（機台主題）' },
  { code: 'product',   label: '商品',        desc: '管理商品與規格' },
  { code: 'catalog',   label: '分類 / 品牌', desc: '管理分類、品牌、選項類型' },
  { code: 'order',     label: '訂單',        desc: '檢視與處理訂單' },
  { code: 'inquiry',   label: '登記管理',    desc: '檢視與處理虛擬商品登記單' },
  { code: 'users',     label: '使用者',      desc: '指派使用者的角色（高權限）' },
  { code: 'roles',     label: '角色權限',    desc: '管理角色與其權限（高權限）' },
  { code: 'membership', label: '會員等級', desc: '管理會員等級（VIP 門檻）' },
];

// code -> label 快速查表（顯示用）
export const PERMISSION_LABEL = PERMISSIONS.reduce((acc, p) => {
  acc[p.code] = p.label;
  return acc;
}, {});
